import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';

export const logoutMutation = createAuthMutation({
	request: {
		method: 'DELETE',
		url: '/auth/out',
		body: {},
	},
	response: {
		contract: zodContract(z.null()),
	},
});
